import { render, staticRenderFns } from "./AlertDeleteModal.vue?vue&type=template&id=21b6e47e&scoped=true&"
import script from "./AlertDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AlertDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertDeleteModal.vue?vue&type=style&index=0&id=21b6e47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6e47e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b6e47e')) {
      api.createRecord('21b6e47e', component.options)
    } else {
      api.reload('21b6e47e', component.options)
    }
    module.hot.accept("./AlertDeleteModal.vue?vue&type=template&id=21b6e47e&scoped=true&", function () {
      api.rerender('21b6e47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/AlertDeleteModal.vue"
export default component.exports